/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PathologyBaseService } from '../pathology-base-service';
import { PathologyApiConfiguration } from '../pathology-api-configuration';
import { PathologyStrictHttpResponse } from '../pathology-strict-http-response';

import { questionareFormIdGet } from '../fn/questionare/questionare-form-id-get';
import { QuestionareFormIdGet$Params } from '../fn/questionare/questionare-form-id-get';
import { QuestionareFormModel } from '../models/questionare-form-model';
import { questionareFormPost } from '../fn/questionare/questionare-form-post';
import { QuestionareFormPost$Params } from '../fn/questionare/questionare-form-post';

@Injectable({ providedIn: 'root' })
export class PATHQuestionareService extends PathologyBaseService {
  constructor(config: PathologyApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `questionareFormIdGet()` */
  static readonly QuestionareFormIdGetPath = '/Questionare/{formId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionareFormIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionareFormIdGet$Response(params: QuestionareFormIdGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<QuestionareFormModel>> {
    return questionareFormIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionareFormIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  questionareFormIdGet(params: QuestionareFormIdGet$Params, context?: HttpContext): Observable<QuestionareFormModel> {
    return this.questionareFormIdGet$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<QuestionareFormModel>): QuestionareFormModel => r.body)
    );
  }

  /** Path part for operation `questionareFormPost()` */
  static readonly QuestionareFormPostPath = '/Questionare/Form';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `questionareFormPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  questionareFormPost$Response(params?: QuestionareFormPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return questionareFormPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `questionareFormPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  questionareFormPost(params?: QuestionareFormPost$Params, context?: HttpContext): Observable<void> {
    return this.questionareFormPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

}
